import { AutoCompleteCustom } from './autoCompleteCustom'

export default AutoCompleteCustom
